import 'keen-slider/keen-slider.min.css';
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { baseUrlWithoutApi } from '../../baseurl';
import 'keen-slider/keen-slider.min.css';
import "swiper/css";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { DateObject } from 'react-multi-date-picker';
import moment from 'jalali-moment';
import "./ADstyles.css"

import axios from 'axios';
import CheckImg from '../CheckImg/CheckImg';

function OneCard({ key, item, onClick, registerStatusCode, anAuctionItem }) {
    const defultImgs = { 1: "/imgs/img-n-1.svg", 2: "/imgs/img-n-2.svg", 3: "/imgs/img-n-3.svg", 4: "/imgs/img-n-4.svg" }
    console.log(item, "item item at oneCard")
    console.log(registerStatusCode, "ifhgdiufhg111111");
    console.log(anAuctionItem, "allAuctionAds at oneCard");
    const currentPath = window.location.pathname
    const status = { 23: "تایید شده", 24: "در انتظار تایید", 25: "رد شده", 26: "در انتظار پرداخت", null: "در انتظار تایید" }
    const [usedInProfilePage, setUsedInProfilePage] = useState(false)
    const navigate = useNavigate();
    const moveDetailPageHandler = async () => {
        if (onClick) {
            onClick()
            return;
        }
        localStorage.setItem("usruserCode", item.usruserCode)
        // navigate(`/AdvertiseDetail/${item.id}`)
    }

    const dateNew = moment.utc(new Date(), "UTC/GMT").local().format().slice(0, 16);
    const [dateStatus, setDateStatus] = useState("no date")
    const dateStatusHandler = async () => {
        if (item) {
            if (item.adsDateTime.slice(0, 13) == dateNew.slice(0, 13)) {
                setDateStatus("دقایقی پیش")
            }
            else if (item.adsDateTime.slice(0, 11) == dateNew.slice(0, 11)) {
                setDateStatus("ساعاتی پیش")
            }
            else if (item.adsDateTime.slice(8, 10) == dateNew.slice(8, 10) - 1) {
                setDateStatus("روز پیش")
            }
            else {
                // else if (item.adsDateTime.slice(0, 5) == dateNew.slice(0, 5)) {
                setDateStatus(new DateObject(item.adsDateTime.slice(0, 10)).convert(persian, persian_fa).format())
            }
        }
    }
    useEffect(() => {
        dateStatusHandler()
    }, [])



    const checkIfImage = async (imageUrl) => {
        if (imageUrl == null) {
            return "/imgs/img-n-1.svg";
        }
        try {
            const res = await axios.get(imageUrl);
            console.log(res);
            return imageUrl; // در صورتی که درخواست موفقیت‌آمیز بود، URL را برمی‌گرداند.
        } catch (err) {
            return "/imgs/img-n-1.svg"; // در صورتی که درخواست ناموفق بود، مسیر پیش‌فرض را برمی‌گرداند.
        }
    };

    // checkIfImage("https://api.veeu.org/Documents/AdvertiseImage/3008/638598394k6480071706bb68.jpg")
    function CheckImage(imageUrlToCheck) {
        const [rndInt, setRndInt] = useState(1)
        const imageUrl = `${baseUrlWithoutApi}${imageUrlToCheck}`;
        const [imageExists, setImageExists] = useState(false);
        useEffect(() => {
            if (imageUrlToCheck) {
                const img = new Image();
                img.src = imageUrl;
                img.onload = () => setImageExists(true);
                img.onerror = () => setImageExists(false);
            } else {
                setRndInt(Math.floor(Math.random() * 4) + 1)
            }
        }, [imageUrl]);
        return (
            imageUrlToCheck ? (
                <div className={`w-1/2 border border-b border-b-2 bg-gray-200 
                    ${imageExists ? "" : "no-img-style"}
                    bg-no-repeat TwoCard style-for-fixed-w-h bg-center bg-cover m-1`}
                    style={{ backgroundImage: `url(${imageExists ? imageUrl : defultImgs[rndInt]})` }}></div>
            ) : (
                <div className={`w-1/2 border border-b border-b-2 bg-gray-200 
                    ${imageExists ? "" : "no-img-style"}
                    bg-no-repeat TwoCard style-for-fixed-w-h bg-center bg-cover m-1`}
                    style={{ backgroundImage: `url(${imageExists ? imageUrl : defultImgs[rndInt]})` }}></div>
            )
        );
    }
    // const rndInt = Math.floor(Math.random() * 4) + 1
    // function CheckImage(imageUrlToCheck) {
    //     const imageUrl = `${baseUrlWithoutApi}${imageUrlToCheck}`;
    //     const [imageExists, setImageExists] = useState(false);
    //     useEffect(() => {
    //         const img = new Image();
    //         img.src = imageUrl;
    //         img.onload = () => setImageExists(true);
    //         img.onerror = () => setImageExists(false);
    //     }, [imageUrl]);
    //     return (
    //         <div className={`w-1/2 border border-b border-b-2 bg-gray-200 
    //             ${imageExists ? "" : "no-img-style"}
    //             bg-no-repeat TwoCard style-for-fixed-w-h bg-center bg-cover m-1`}
    //             style={{ backgroundImage: `url(${imageExists ? imageUrl : defultImgs[rndInt]})` }}></div>
    //     );
    // }
    useEffect(() => {
        if (currentPath === '/Profile' && !usedInProfilePage) {
            setUsedInProfilePage(true);
        }
    }, [currentPath, usedInProfilePage]);


    return (
        <>
            {/* <div onClick={() => moveDetailPageHandler()}
                className={`Two_frame bg-red-200
             ${item?.adsAdvertiseTypeCode == 2 ? "auction" : ""}  `}> */}
            <Link
                to={`/AdvertiseDetail/${item.id}`}  // fallback URL (won't be used due to preventDefault)
                className={`Two_frame bg-red-200
                    ${item?.adsAdvertiseTypeCode == 2 ? "auction" : ""}  `}
                    onClick={moveDetailPageHandler}
            // onClick={async (e) => {
            //     e.preventDefault(); // prevent the immediate navigation
            //     await moveDetailPageHandler();
            // }}
            >
                {console.log(item, "item in One Card")}

                {usedInProfilePage && <p className='absolute -top-2 left-0 text-sm'>
                    {status[registerStatusCode]}
                </p>}
                {
                    item.adsAdvertiseTypeCode == 2 ? (
                        <div className='relative'>
                            <div className='z-13 text-white px-1 bg-[#B90023] absolute h-[28px] top-[-12px] right-2 flex justify-between items-center gap-1 rounded rounded-lg'>
                                <img src="/icons/SalesIcon.svg" alt="" />
                                <p className='text-sm'>حراجی</p>
                            </div>
                        </div>
                    ) : ""
                }
                <div className='overflow-hidden flex two-card'>


                    {CheckImage(item.firstMasterImage)}
                    {CheckImage(item.secondMasterImage)}
                </div>

                <div className='p-1 w-full  h-[55%] flex flex-col items-center justify-between'>
                    <p className={`my-2 ${item.isAuction ? "text-[#B90023]" : "text-gray-800"} text-center text-[14px] font-bold mb-2 text-ellipsis overflow-hidden  line-clamp-1 view-profile-step`}>
                        {item.adsTitle}
                    </p>
                    {
                        item.detailInMasterCode == 9 ? <div className='flex flex-col  w-full justify-between gap-2 items-center text-[14px] font-bold text-gray-500'>
                            <div className='flex w-full justify-between'>
                                <p>کمترین اجاره:</p>
                                {
                                    item.minShortTermRentPrice ? (<p>{item.minShortTermRentPrice.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                }
                            </div>
                        </div> :
                            (
                                item.adsMainCategoryCode == 1 ? (
                                    <div className={` flex items-center justify-between  w-full `}>
                                        {
                                            item.br_IsApplicantRentBuyProperty ? (
                                                <>
                                                    <div className='text-center  text-[14px] font-bold text-gray-500 w-full flex items-center justify-center'>
                                                        {
                                                            item.br_ApplicantType == 10 ? (
                                                                <div className='w-full flex gap-1 items-center justify-center flex-col'>
                                                                    <p> ودیعه:</p>
                                                                    {
                                                                        item.deposit ? (<p>{item.deposit.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className='w-full flex gap-1 items-center justify-center flex-col'>
                                                                    <p>متری:</p>
                                                                    {
                                                                        item.pricePerMeter ? (<p>{item.pricePerMeter.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                    {/* <div className='w-[3px] h-[33px] bg-gray-400 rounded'></div> */}
                                                    <div className='text-center  text-[14px] font-bold text-gray-500 w-full'>
                                                        {
                                                            item.br_ApplicantType = 10 ? (
                                                                <div className='w-full flex gap-1 items-center justify-center '>
                                                                    <p>اجاره:</p>
                                                                    {
                                                                        item.rentPerMonth ? (<p>{item.rentPerMonth.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className='w-full flex gap-1 items-center justify-center'>
                                                                    <p>کل:</p>
                                                                    {
                                                                        item.totalPrice ? (<p>{item.totalPrice.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div className='text-center  text-[14px] font-bold  w-full flex items-center justify-center'>
                                                        {
                                                            item.isForRent ? (
                                                                <div className='w-full flex gap-1 items-center justify-center flex-col'>
                                                                    <p className='text-gray-500'>ودیعه:</p>
                                                                    {
                                                                        item?.tblAdsPrptyDetails[0]?.deposit ? (<p>{item?.tblAdsPrptyDetails[0]?.deposit.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className='w-full flex gap-1 items-center justify-center flex-col'>
                                                                    <p className='text-gray-500'>متری:</p>
                                                                    {
                                                                        item?.tblAdsPrptyDetails[0]?.pricePerMeter ? (<p>{item?.tblAdsPrptyDetails[0]?.pricePerMeter.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            )
                                                        }

                                                    </div>
                                                    {/* <div className='w-[3px] h-[33px] bg-gray-400 rounded'></div> */}
                                                    <div className='text-center  text-[14px] font-bold w-full'>
                                                        {
                                                            item.isForRent ? (
                                                                <div className='w-full flex gap-1 items-center justify-center flex-col'>
                                                                    <p className='text-gray-500'>اجاره:</p>
                                                                    {
                                                                        item?.tblAdsPrptyDetails[0]?.rentPerMonth ? (<p>{item?.tblAdsPrptyDetails[0]?.rentPerMonth.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            ) : (
                                                                <div className='w-full flex gap-1 items-center justify-center flex-col'>
                                                                    <p className='text-gray-500'>کل:</p>
                                                                    {
                                                                        item?.tblAdsPrptyDetails[0]?.totalPrice ? (<p>{item?.tblAdsPrptyDetails[0]?.totalPrice.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                                                    }
                                                                </div>
                                                            )
                                                        }
                                                    </div>
                                                </>
                                            )
                                        }

                                    </div>
                                ) : (
                                    <div className='flex w-full items-center justify-start font-bold text-gray-500 text-[13px] '>
                                        <p className='ml-12'>قیمت:</p>
                                        {
                                            item.price ? (<p>{item.price.toLocaleString('fa')} تومان</p>) : (<p>توافقی</p>)
                                        }
                                    </div>
                                )
                            )

                    }

                    <div className='w-full flex items-center justify-between'>
                        <p className='text-gray-500 text-[14px]'>
                            {
                                dateStatus
                            }
                        </p>
                        <p className='  text-[12px] font-bold text-gray-500  flex items-center mt-3 gap-1 '>
                            {/* <span>در محله</span> */}
                            {item.area}
                        </p>
                        <div className='text-gray-500 text-[12px] flex items-center justify-between'>
                            <div className='flex flex-col justify-center items-center p-1 rounded'>
                                <img src="/icons/new-like.svg" className='w-3.5 h-3.5' alt="" />
                                <p>{item.likesCount == 0 ? "--" : item.likesCount.toLocaleString('fa')}</p>
                            </div>
                            <div className='flex flex-col justify-center items-center  p-1 rounded'>
                                <img src="/icons/new-view.svg" className='w-3.5 h-3.5' alt="" />
                                <p>{item.viewsCount == 0 ? "--" : item.viewsCount.toLocaleString('fa')}</p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </Link>
        </>
    )
}

export default OneCard